module.exports = __webpack_public_path__ + "static/media/password-auditing-165x165.919077fe.png";